<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-award`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 1c10.493 0 19 8.507 19 19 0 7.237-4.046 13.529-10 16.737v8.47a2 2 0 01-2.645 1.893L23 44.937 16.645 47.1A2 2 0 0114 45.206v-8.468C8.048 33.53 4 27.238 4 20 4 9.507 12.507 1 23 1zm5.5 37.5h-1.154c-1.396.327-2.85.5-4.346.5-1.495 0-2.95-.173-4.346-.5H17.5v4.611L23 41.24l5.5 1.872V38.5zM8 20c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15zm15-9a9 9 0 110 18 9 9 0 010-18zm-5 9a5 5 0 1110 0 5 5 0 01-10 0z"/></svg>
</template>
<script>

export default {
  name: 'IconAward',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
